<script>
    import csvDownload from "json-to-csv-export";

    export let data;
    export let summary;
    export let disabled;
    export let name;


    function exportCSV(data) {
        if(Object.keys(summary).length > 0){
            const firstKey = Object.keys(data[0])[0]
            const summaryObject = {...summary}
            summaryObject[firstKey] = 'Summary';
            data.push(summaryObject)
        }
        const dataToConvert = {
            data: data,
            filename: name.replaceAll(' ',''),
            delimiter: ","
        };
       csvDownload(dataToConvert)
    }
</script>

<button
    type="button"
    disabled={disabled}
    on:click={() => exportCSV(data)}
    class="w-30 h-12 relative inline-flex items-center justify-center px-1 py-1 rounded-md border 
    shadow-nv border-custom-orange bg-custom-orange text-sm font-medium text-white 
    hover:bg-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 
    focus:border-blue-600"
>
    <slot>
        <span class="mr-2">Export</span>
    </slot>
</button>
